import { getAccessToken } from './client';

export interface UploadFileOptions {
  usage: string;
  file: File;
  extraFields?: Record<string, string>;
}

export interface UploadFileResult {
  id: number;
  key: string;
  mimeType: string;
}

// ─── Helper d'upload générique ──────────────────────────
// Factorise le pattern FormData + fetch direct (bypass api.post car multipart).
// Lit VITE_URL_API depuis l'environnement de l'app consommatrice (injecté par Vite au build).
export async function uploadFileApi(opts: UploadFileOptions): Promise<UploadFileResult> {
  const apiUrl = (import.meta.env.VITE_URL_API as string | undefined)?.replace(/\/$/, '') ?? 'http://localhost:3230';
  const token = getAccessToken();

  const formData = new FormData();
  formData.append('file', opts.file);
  formData.append('usage', opts.usage);
  if (opts.extraFields) {
    for (const [k, v] of Object.entries(opts.extraFields)) {
      formData.append(k, v);
    }
  }

  const res = await fetch(`${apiUrl}/v1/files/upload`, {
    method: 'POST',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
    body: formData,
  });

  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(err.message ?? "Erreur lors de l'upload du fichier");
  }

  const json = (await res.json()) as { success?: boolean; data?: unknown };
  return (json.success ? json.data : json) as UploadFileResult;
}

export async function deleteFileApi(fileId: number): Promise<void> {
  const apiUrl = (import.meta.env.VITE_URL_API as string | undefined)?.replace(/\/$/, '') ?? 'http://localhost:3230';
  const token = getAccessToken();

  const res = await fetch(`${apiUrl}/v1/files/${fileId}`, {
    method: 'DELETE',
    headers: token ? { Authorization: `Bearer ${token}` } : {},
    credentials: 'include',
  });

  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { message?: string };
    throw new Error(err.message ?? 'Erreur lors de la suppression du fichier');
  }
}
